import React, {Component} from "react";
import ReportView from "./ReportView";
import DashboardTaskTraining from "../dashboard/DashboardTaskTraining";
import './ReportViewSplit.scss'
import classNames from "classnames";
import CustomForm from "../../../shared/components/form/CustomForm";
import Modal from "../../../shared/ui/Modal";
import trainingPhasesActionCreators from "../../store/training-phases/action-creators";
import trainingPhasesActions from "../../store/training-phases/action-creators";
import {connect} from "react-redux";
import dashboardActionCreators from "../../store/dashboard/action-creators";
import oitsActionCreators from "../../store/oits/action-creators";

class ReportViewSplit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showChangeReportPhaseDialog: false,
      currentChangePhaseReportGuid: null,
      currentChangePhase: null
    }
  }

  get oit() {
    return this.props.oits.find(o => o.guid === this.props.report.oitGuid)
  }

  get changePhaseConfig() {
    return {
      fields: {
        phase: {
          type: 'select',
          label: 'Phase',
          value: 'value',
          optionLabel: 'label',
          options: this.oit.trainingPhases.map(tp => ({
            value: tp.trainingPhaseGuid,
            label: tp.header
          }))
        },
        datetime: {
          type: 'date',
          label: 'Report date (optional)'
        }
      }
    }
  }

  updateReportPhase(data) {
    this.props.updateReport({...data, datetime: data.datetime, guid: this.state.currentChangePhaseReportGuid})
      .then(() => this.props.viewTrainingPhase(data.phase))
      .then(() => {
        this.setState({
          showChangeReportPhaseDialog: false
        })
      })

  }
  openTasks(report) {
    this.props.onSplitScreen && this.props.onSplitScreen(true)
  }

  async onChangePhase(report) {
    console.log('onChangePhase', this.props)
    if(!this.props.oits) {
      await this.props.loadOitsContainer()
    }
    this.setState({
      showChangeReportPhaseDialog: true,
      currentChangePhaseReportGuid: report.guid,
      currentChangePhase: {
        phase: report.trainingPhaseGuid,
        datetime: report.responses[0] && report.responses[0].datetime ? (report.responses[0].datetime.split('T')[0]) : null
      }
    })
  }
  render() {
    return (
      this.props.report ? <div className={classNames("modal-split-content")}>
        <div className="main-modal-content">
          <ReportView
            report={this.props.report}
            onOpenTasks={(report) => this.openTasks(report)}
            onChangePhase={(report) => this.onChangePhase(report)}
          />
        </div>
        {this.props.isSplitScreen &&
          <div className="side-modal-content">
            <DashboardTaskTraining oitGuid={this.props.report.oitGuid} />
          </div>
        }

        <Modal
          isOpen={this.state.showChangeReportPhaseDialog}
          onClose={() => this.setState({
            showChangeReportPhaseDialog: false
          })}
          fullscreen={true}
          title="Change phase">
          {this.state.showChangeReportPhaseDialog && (
            <CustomForm
              config={this.changePhaseConfig}
              initialValues={this.state.currentChangePhase}
              onSubmit={(data) => this.updateReportPhase(data)}
            />
          )}
        </Modal>
      </div>: <div></div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    oits: state.oits.list,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateReport: (formData) => {
      return dispatch(trainingPhasesActionCreators.updateReport(formData));
    },
    viewTrainingPhase: (phaseGuid) => {
      return dispatch(trainingPhasesActions.viewTrainingPhase(phaseGuid));
    },
    loadOitsContainer: (scope, status) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope, status));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportViewSplit)
